import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { NavigationService } from '@treasury/core/navigation';
import { StopPayment } from '@treasury/domain/stop-payments';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/layout/tm-section';
import '@treasury/presentation/components/tm-footer';
import { ButtonConfig } from '@treasury/presentation/components/tm-footer.types';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../components/confirmation-container';
import './readonly-stop-payment.template';
// eslint-disable-next-line no-duplicate-imports
import { ConfirmationType } from '../../components/confirmation-container';

export const tagName = 'stop-payment-confirm-step';
@customElement(tagName)
export class StopPaymentConfirmStep extends TmBaseComponent {
    @property({ type: Object })
    public stopPayment!: StopPayment;

    @property({ type: Boolean })
    public isEdit = false;

    @InjectProperty()
    private navigationService!: NavigationService;

    private get headingText() {
        if (this.isEdit) {
            return 'Stop payment updated';
        }

        return 'Stop payment added';
    }

    private get confirmationType() {
        return ConfirmationType.Success;
    }

    protected render() {
        return html`
            <tm-section class="mb-2 p-6"
                ><confirmation-container
                    .headingText=${this.headingText}
                    .confirmationType=${this.confirmationType}
                    ><readonly-stop-payment
                        .stopPayment=${this.stopPayment}
                    ></readonly-stop-payment>
                </confirmation-container>
            </tm-section>
            ${this.renderFooter()}
        `;
    }

    protected renderFooter() {
        const buttons: ButtonConfig[] = [
            {
                text: this.isEdit ? 'Update stop payment' : 'Add another stop payment',
                importance: 'secondary',
                onClick: () =>
                    this.dispatchEvent(
                        new CustomEvent('create-new', { bubbles: true, composed: true })
                    ),
            },
            {
                text: 'View stop payment activity',
                importance: 'secondary',
                onClick: () => {
                    this.navigationService.navigate('/stop-payments');
                },
            },
        ];
        return html`<tm-footer .buttonConfig=${buttons}></tm-footer>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-direction: column;
                    height: 100vh;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: StopPaymentConfirmStep;
    }
}
